export default __webpack_public_path__ + "static/media/oe-4-lqMAX.62e45b25.jpg";